import Error404 from './Error404';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import usePiwikPro from '../../core/hooks/usePiwikPro';
import { ERROR_404_PAGE } from '../../core/PiwikConstants';

interface Props {
    testId?: string;
}

export default function Error404Page({ testId = 'Error404Page' }: Props) {
    const { trackPageView } = usePiwikPro();

    useEffect(() => {
        trackPageView(ERROR_404_PAGE);
    }, []);

    const history = useHistory();
    const handleHomeClick = () => {
        history.push({
            pathname: '/',
        });
    };

    return <Error404 testId={testId} onHomeClick={handleHomeClick} />;
}
